export default [
    "COMPOSITION_SELECTION_GRID",
    "COMPOSITION_SELECTION",
    "SLIDER",
    "WAITING_PRINT",
    "PRINTING",
    "PRINT_ABORDED",
    "PRINT_ERROR",
    "PRINT_SUCCESS",
    "RESULT_IMAGE"
]